import { Component, ViewChild, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { environment } from '../../environments/environment';
import { DynamicFormComponent } from '../_dynamic_form/containers/dynamic_form/dynamic-form.component';
import { OwnerUserService } from '../_services/owner-user.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-u-owner-users',
    templateUrl: './u-owner-users.component.html',
    styleUrls: ['./u-owner-users.component.css']
})
export class UOwnerUsersComponent implements OnInit {

    @ViewChild(DynamicFormComponent) filterForm: DynamicFormComponent;

    users: any[] = [];
    selectedUser: any;

    storeId: any;

    filters: any;

    sidebarVisible = false;
    createUserModal = false;
    createUserForm: FormGroup;
    errMsgs: any[] = [];

    pageSizes: any = environment.pageSizes;
    pagination: any;

    selectedSort: any;

    sortFields: any[] = [
        {
            sortName: 'First Name (asc)',
            sortString: 'bludotUser.user.firstName,asc'
        },
        {
            sortName: 'First Name (desc)',
            sortString: 'bludotUser.user.firstName,desc'
        },
        {
            sortName: 'Last Name (asc)',
            sortString: 'bludotUser.user.firstName,asc'
        },
        {
            sortName: 'Last Name (desc)',
            sortString: 'bludotUser.user.firstName,desc'
        },
        {
            sortName: 'Organisation (asc)',
            sortString: 'bludotUser.user.firstName,asc'
        },
        {
            sortName: 'Organisation (desc)',
            sortString: 'bludotUser.user.firstName,desc'
        }
    ];

    filterFields: any[] = [
        {
            type: 'input',
            label: 'First Name',
            name: 'name',
            placeholder: 'Enter first name'
        },
        {
            type: 'input',
            label: 'Last Name',
            name: 'name',
            placeholder: 'Enter first name'
        },
        {
            type: 'input',
            label: 'Organisation Name',
            name: 'name',
            placeholder: 'Enter organisation name'
        },
        {
            label: 'Submit',
            name: 'submit',
            type: 'button'
        }
    ];

    constructor(
        public loader: LoadingBarService,
        public activatedRoute: ActivatedRoute,
        public router: Router,
        public globals: Globals,
        public fb: FormBuilder,
        public notificationService: NotificationService,
        public _ownerUserService: OwnerUserService
    ) {
        this.createUserForm = fb.group({
            firstName: new FormControl('', [Validators.required]),
            lastName: new FormControl('', [Validators.required]),
            email: new FormControl('', [Validators.required]),
            password: new FormControl('', [Validators.required]),
            repeatedPassword: new FormControl('', [Validators.required]),
            organisation: new FormControl('')
        });

        this.storeId = globals.store.id;
        this.selectedSort = this.sortFields[0];
        this.resetPagination();
    }

    ngOnInit() {
        this.getAllOwners();
    }

    public getAllOwners() {
        this._ownerUserService.getAllOwners(this.pagination, this.selectedSort.sortString)
            .subscribe((data: any) => {
                console.log(data);
                this.users = data.body;
                this.pagination.totalRecords = data.headers.get('x-total-count');
            })
    }

    /* PAGINATION */
    public resetPagination() {
        this.pagination = {
            size: this.pageSizes[0],
            page: 0,
            totalRecords: 0
        }
    }

    paginate(event) {
        console.log(event);
        this.pagination.size = event.rows;
        this.pagination.page = event.page;
    }
    /* PAGINATION END */



    // Handle onRowSelect (ie Select Single Patient and navigate to inner view)
    onRowSelect(event) {
        this.router.navigate(['/' + this.globals.user.routeRole + '/products/' + event.data.id]);
    }

    public toggleCreateUserModal() {
        this.createUserModal = !this.createUserModal;
    }

    public onCreateUserFormSubmit() {
        this.errMsgs = [];
        const values = this.createUserForm.value;
        if (values.password !== values.repeatedPassword) {
            this.errMsgs.push({severity: 'warn', summary: 'Passwords Do Not Match', detail: 'Passwords must match!'});
        } else {
            const body = {
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email,
                login: values.email,
                organisation: values.organisation,
                password: values.password,
                groupUserId: null
            }
            this._ownerUserService.createOwner(body)
                .subscribe((data: any) => {
                    this.toggleCreateUserModal();
                    this.createUserForm.reset();
                    this.getAllOwners();
                    this.notificationService.notify(
                        'success',
                        'Store Owner Created',
                        'New Store Owner has successfully been created',
                        'top',
                        'right');
                })
        }
    }

    sortChange(event) {
        this.selectedSort = event;
        this.getAllOwners();
        this.resetPagination();
    }

    filterFormSubmitted(value) {
        this.sidebarVisible = false;
        this.filters = value;
        this.resetPagination();
    }


    clearFilters() {
        this.sidebarVisible = false;
        this.filters = '';
        this.filterForm.clearForm();
        this.resetPagination();
    }

    // Change Password
    public changerPassword(user) {
        // (Swal as any).mixin({
        //     input: 'text',
        //     confirmButtonText: 'Next &rarr;',
        //     showCancelButton: true,
        //     progressSteps: ['1', '2']
        //   }).queue([
        //     {
        //       title: 'Enter New Password',
        //       text: 'Please enter a new password.'
        //     }
        //   ]).then((result) => {
        //     if (result.value) {
        //         Swal.fire({
        //           title: 'Confirm',
        //           text: 'Change Site Owner password to the following?',
        //           html:
        //             'New Password: <pre><code>' +
        //               JSON.stringify(result.value[0]) +
        //             '</code></pre>',
        //           confirmButtonText: 'Confirm'
        //         }).then((res) => {
        //           if (res.value) {
        //               const body = {
        //                   newPassword: result.value[0],
        //                   bludotUserId: this.selectedUser.id
        //               }
        //             this._ownerUserService.updateSiteOwnerPassword(body)
        //               .subscribe(response => {
        //                 Swal.fire(
        //                     'Success',
        //                     'Site Owner Password Changed!',
        //                     'success'
        //                     )
        //               })
        //           }
        //         });
        //     }
        //   });
    }


}



// WEBPACK FOOTER //
// ./src/app/u-owner-users/u-owner-users.component.ts